import type { FC } from 'react';

import type { RouteComponentProps } from '@xing-com/crate-core-router';
import { useLocation } from '@xing-com/crate-core-router';
import { ShareTabFrame } from '@xing-com/crate-social-share';
import type { BackendTrackingMetaData } from '@xing-com/crate-social-types';

import { ExternalShareFrame } from '../external-share-frame/external-share-frame';

export const ShareFrame: FC<RouteComponentProps> = () => {
  const location = useLocation();
  const locationParams = new URLSearchParams(location.search);
  const urn = locationParams.get('urn');
  const url = locationParams.get('url');
  const trackingId = locationParams.get('trackingId');

  if (url === null) {
    return null;
  }

  const backendTrackingMetaData: BackendTrackingMetaData =
    trackingId === null
      ? {}
      : {
          page: '',
          trackingTokens: [trackingId],
          position: '',
        };

  if (urn === null) {
    return <ExternalShareFrame {...{ url, backendTrackingMetaData }} />;
  }

  return (
    <ShareTabFrame
      verb="POST"
      url={url}
      interactionTargetUrn={urn}
      propChannel="wbm/Share_Extension"
      entryPoint="share_extension_social_share"
      onCancel={() => window.close()}
      onSuccess={() => window.close()}
      openWithShareTo="FEED"
      backendTrackingMetaData={backendTrackingMetaData}
    />
  );
};
